import React from 'react';
import AppHeader from '../Layout/Header';
import FooterComponent from '../Layout/Footer';
import '../Styles/AboutStyles.css'; // Import the CSS for the background image and styling
import NCGSAComponent from '../Components/AboutComponents/NcgsaComponent';
import ScientificObjectives from '../Components/AboutComponents/ScientificObjectives';
import ResearchDomains from '../Components/AboutComponents/ResearchDomains';
import PartnerUniversities from '../Components/AboutComponents/PartnerUniversities';
import NationalSteeringCommittee from '../Components/AboutComponents/NationalSteeringCommittee';
import SecretariatComponent from '../Components/AboutComponents/SecretariatComponent';
import FooterQuote from '../Layout/FooterQuote';
const AboutPage = () => {
  return (
    <div>
      <AppHeader />

      {/* About section with background image */}
      <div className="about-section" role="img" aria-label="About NCGSA — shaping the future of space and innovation" />
      <main className="page-content-bands">
      <section id="ncgsa-section">
        <NCGSAComponent/>
      </section>

      <section id="scientific-objectives">
        <ScientificObjectives/>
      </section>

      <section id="research-domains">
        <ResearchDomains/>
      </section>

      <section id="partner-universities">
       <PartnerUniversities/>
      </section>

      <section id="national-steering-committee">
       <NationalSteeringCommittee/>
      </section>

      <section id="secretariat">
       <SecretariatComponent/>
      </section>

      </main>
      <FooterQuote
        variant="about"
        quote="You do not see in the creation of the Most Merciful any inconsistency. So return your vision to the sky: do you see any breaks?"
        attribution="Qur’an 67:3"
      />
      <FooterComponent />
    </div>
  );
};

export default AboutPage;
